export const defaultTheme = {
  colors: {
    primaryText: "#14141d",
    secondaryText: "#2b2a35",
    secondaryBackground: "#0c182b",
  },
}

export type ThemeType = typeof defaultTheme
